var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94922 23.6841C7.94922 23.3541 8.20922 22.9941 8.62797 22.9941H10.9367C12.2367 22.9941 13.4067 23.8641 13.4067 25.5316C13.4067 27.1116 12.2367 27.9916 10.9367 27.9916H9.26797V29.3116C9.26797 29.7516 8.98797 30.0004 8.62797 30.0004C8.29797 30.0004 7.94922 29.7516 7.94922 29.3116V23.6841ZM9.26797 24.2529V26.7429H10.9367C11.6067 26.7429 12.1367 26.1516 12.1367 25.5316C12.1367 24.8329 11.6067 24.2529 10.9367 24.2529H9.26797Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3638 30.0002C15.0338 30.0002 14.6738 29.8202 14.6738 29.3815V23.704C14.6738 23.3452 15.0338 23.084 15.3638 23.084H17.6526C22.2201 23.084 22.1201 30.0002 17.7426 30.0002H15.3638ZM15.9938 24.304V28.7815H17.6526C20.3513 28.7815 20.4713 24.304 17.6526 24.304H15.9938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7401 24.3843V25.973H26.2889C26.6489 25.973 27.0089 26.333 27.0089 26.6818C27.0089 27.0118 26.6489 27.2818 26.2889 27.2818H23.7401V29.3805C23.7401 29.7305 23.4914 29.9993 23.1414 29.9993C22.7014 29.9993 22.4326 29.7305 22.4326 29.3805V23.703C22.4326 23.3443 22.7026 23.083 23.1414 23.083H26.6501C27.0901 23.083 27.3501 23.3443 27.3501 23.703C27.3501 24.023 27.0901 24.383 26.6501 24.383H23.7401V24.3843Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.db40bd6a77e51c43891ddd59654569fd.svg";
export { ForwardRef as ReactComponent };